import { useStaticQuery, graphql } from 'gatsby';

const useWhatsNewUpdateQuery = () => {
  const query = useStaticQuery(graphql`
  query WpWhatsNewUpdateQuery {
    allWpWhatsNewUpdate {
      nodes {
        databaseId
        title
        post_topic {
          postTopic
        }
        release_type {
          releaseType
        }
        templatesWhatsNewUpdate {
          buttons {
            leftIcon {
              iconName
            }
            openInNewTab
            rightIcon {
              iconName
            }
            text
            url
          }
          description
          image {
            altText
            localFile {
              childImageSharp {
                gatsbyImageData
              }
              publicURL
            }
            gatsbyImage: wpGatsbyImage(
              placeholder: BLURRED
              width: 488
            )
          }
          postDate
          quarterlyRecap
          quarterlyRecapTitle
          quarterlyRecapVideo
        }
      }
    }
  }
  `);

  return query;
};

export default useWhatsNewUpdateQuery;
